module.exports = __webpack_public_path__ + "static/media/amex-logo.10887314.jpg";